<div class="container">
  <div class="gift-cards-banner-container">
    <div class="cards-banner-content">
      <div class="fw-bold card-banner-title"
           [translate]="'giftCards.banners.home.title'">
        Gift card for cakes. Yes, they do exist
      </div>

      <div class="mb-4 mt-2 pb-2 card-banner-description"
           [translate]="'giftCards.banners.home.description'">
        We offer a gift card that can be used to buy cakes from over 400 bakeries all over the country.
      </div>

      <button class="btn btn-primary fw-normal cards-read-more-btn"
              [translate]="'giftCards.banners.home.readMore'"
              (click)="onReadMore.emit()">
        Read about our gift card
      </button>
    </div>

    <div class="glad-gavecord-wrap ms-0 ml-md-min-4">
      <img src="/assets/img/content/glad-gavekort.jpeg" [alt]="'giftCards.banners.home.title' | translate">
    </div>
  </div>
</div>
